import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const APP_SCHEME = process.env.REACT_APP_APP_SCHEME || 'org.kjri.sconewyork';
const ANDROID_PACKAGE =
  process.env.REACT_APP_ANDROID_PACKAGE || 'org.kjri.consulateconnect';
const IOS_STORE_URL = process.env.REACT_APP_IOS_STORE_URL || 'https://apps.apple.com';
const PLAY_STORE_URL =
  process.env.REACT_APP_ANDROID_STORE_URL ||
  `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

const getPlatform = () => {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
};

const RegistrationDeepLink = ({ children }) => {
  const [platform] = useState(getPlatform);
  const [view, setView] = useState(platform === 'desktop' ? 'web' : 'opening');

  useEffect(() => {
    if (platform === 'desktop') return undefined;

    const path = window.location.pathname + window.location.search;
    const startedAt = Date.now();
    const timer = setTimeout(() => setView('fallback'), 3000);
    const onLeave = () => {
      if (document.hidden && Date.now() - startedAt < 1500) {
        clearTimeout(timer);
      }
    };

    document.addEventListener('visibilitychange', onLeave);
    window.addEventListener('pagehide', onLeave);

    if (platform === 'ios') {
      window.location.href = `${APP_SCHEME}://${path.replace(/^\//, '')}`;
    } else {
      window.location.href = `intent://${path.replace(
        /^\//,
        ''
      )}#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(
        PLAY_STORE_URL
      )};end;`;
    }

    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onLeave);
      window.removeEventListener('pagehide', onLeave);
    };
  }, [platform]);

  if (view === 'web') {
    return children;
  }

  if (view === 'opening') {
    return (
      <div className='registration-deeplink'>
        <div className='registration-deeplink__spinner' />
        <p>Membuka aplikasi SCO KJRI...</p>
      </div>
    );
  }

  return (
    <div className='registration-deeplink registration-deeplink--fallback'>
      <h2>Lanjutkan di Aplikasi SCO KJRI</h2>
      <p>
        Anda belum memiliki aplikasi SCO KJRI. Silakan unduh aplikasi terlebih dahulu,
        lalu kembali membuka tautan dari email Anda.
      </p>
      <div className='registration-deeplink__actions'>
        <a
          className='registration-deeplink__button'
          href={IOS_STORE_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          App Store
        </a>
        <a
          className='registration-deeplink__button'
          href={PLAY_STORE_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          Google Play
        </a>
        <button
          className='registration-deeplink__link'
          type='button'
          onClick={() => setView('web')}
        >
          Lanjutkan di website
        </button>
      </div>
    </div>
  );
};

RegistrationDeepLink.propTypes = {
  children: PropTypes.node
};

export default RegistrationDeepLink;
